import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import Header from "@/components/Header";
import BottomBar from "@/components/BottomBar";
import walletCreation01 from "@/assets/images/help/wallet-creation-01.png";
import walletCreation02 from "@/assets/images/help/wallet-creation-02.png";
import walletCreation03 from "@/assets/images/help/wallet-creation-03.png";

export default function HelpWalletCreation() {
  const navigate = useNavigate();

  const steps = [
    {
      title: "Step 1: Start Wallet Creation",
      description: "Click the \"Create Wallet\" button.",
      image: walletCreation01,
    },
    {
      title: "Step 2: Create Wallet",
      description: "Click the \"Create Wallet\" button to generate your wallet.",
      image: walletCreation02,
    },
    {
      title: "Step 3: Wallet Creation Completed",
      description: "Your wallet has been successfully created.",
      image: walletCreation03,
    },
  ];

  return (
    <div className="min-h-screen bg-background">
      <Header showBack={true} onBackClick={() => navigate("/help")} />

      <div className="max-w-md mx-auto px-4 pb-20">
        {/* Title */}
        <div className="mt-6 mb-6">
          <h1 className="text-2xl font-bold mb-2">
            User Verification Step 4: Wallet Creation
          </h1>
          <p className="text-sm text-muted-foreground">
            Once KYC verification is complete, a personal wallet must be created
            to use Fellas Card.
            {"\n\n"}
            This wallet will be used for card payments, asset management,
            top-ups, and more.
          </p>
        </div>

        {/* Steps */}
        <div className="space-y-8">
          {steps.map((step, index) => (
            <div key={index} className="space-y-4">
              <h3 className="text-lg font-bold opacity-90">{step.title}</h3>
              <p className="text-sm font-semibold whitespace-pre-line">
                {step.description}
              </p>
              <div className="rounded-lg overflow-hidden shadow-md">
                <img
                  src={step.image}
                  alt={`Step ${index + 1}`}
                  className="w-full h-auto"
                />
              </div>
            </div>
          ))}
        </div>

        {/* Completion Note */}
        <div className="mt-8 p-4 bg-primary/5 rounded-lg">
          <p className="text-sm font-semibold whitespace-pre-line">
            You have now completed user verification and wallet setup for Fellas
            Card.
            {"\n\n"}
            In the next steps, you will be guided on how to purchase a card,
            register it, and top it up.
          </p>
        </div>

        {/* Next Step */}
        <div className="mt-8">
          <Button
            onClick={() => navigate("/help/7")}
            className="w-full h-12 flex items-center justify-between"
          >
            <span>Next: Node Card Screen Guide</span>
            <ChevronRight className="w-5 h-5" />
          </Button>
        </div>
      </div>

      <BottomBar />
    </div>
  );
}
